"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMoveItem = void 0;

var arrayMoveItem = function arrayMoveItem(array, oldIndex, newIndex) {
  if (newIndex >= array.length) {
    var spotsToFill = newIndex - array.length;

    while (spotsToFill) {
      array.push(undefined);
      spotsToFill -= 1;
    }
  }

  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
};

exports.arrayMoveItem = arrayMoveItem;